AFRAME.registerComponent('cursor-listener', {
    init: function () {
        this.originalColor =  this.el.getAttribute('color') || '#0066cc';

        this.el.addEventListener('mouseenter', () => {
            this.el.setAttribute('material', 'opacity', 1.0);
            this.el.setAttribute('color', '#3399ff');
        });

        this.el.addEventListener('mouseleave', () => {
            this.el.setAttribute('material', 'opacity', 0.8);
            this.el.setAttribute('color', this.originalColor);
        });
    }
});

AFRAME.registerComponent('ticker-news', {
    schema: {
        ticker: { type: 'string', default: 'BUSINESS' },
        position: { type: 'vec3' }
    },

    init: async function () {
        this.articles = [];
        this.overlay = null;
        this.currentFilter = 'general';
        this.activeWatchlistId = null;

        this.themeMode = 'Dark'
        const mainSettings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
            this.themeMode = mainSettings.themeMode;
        }
        this.mainContentColor = (this.themeMode === 'Dark') ? '#fff' : '#111';

        this.onFilterChanged = this.onFilterChanged.bind(this);
        this.onWatchlistDataLoaded = this.onWatchlistDataLoaded.bind(this);
        this.onThemeChanged = this.onThemeChanged.bind(this);

        this.el.sceneEl.addEventListener('news-filter-changed', this.onFilterChanged);
        document.body.addEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        this.el.sceneEl.addEventListener('theme-changed', this.onThemeChanged);

        try {
            this.apiManager = await NewsProxyAPIManager.create();
        } catch (error) {
            console.error('init: Failed to initialize MediastackAPIManager: ', error.message);
            return;
        }
        
        this.el.sceneEl.addEventListener('watchlist-button-clicked', () => {});

        this.el.sceneEl.addEventListener('chart-type-changed', (evt) => {
            const action = evt.detail.action;
            
            if (action === 'watchlist-reports') {
                if (this.currentFilter !== 'watchlist') {
                    this.el.sceneEl.emit('set-news-filter-ui', { filter: 'watchlist' });
                    
                    this.onFilterChanged({ detail: { filter: 'watchlist' } });
                }
            } else {
                if (this.data.ticker !== 'BUSINESS') {
                    this.el.setAttribute('ticker-news', 'ticker', 'BUSINESS');
                }

                if (this.currentFilter !== 'general') {
                    this.el.sceneEl.emit('set-news-filter-ui', { filter: 'general' });
                    this.onFilterChanged({ detail: { filter: 'general' } });
                }
            }
        });


        try {
            this.articles = await this.fetchArticles();
            this.news = this.createNews(this.articles);
        } catch (error) {
            console.error('init: Failed to fetch articles:', error.message);
            if (!this.news) {
                this.news = this.createNews([]);
            }
            this.showError(this.news, 'Failed to fetch articles: ' + error.message);
        }

        const leftNewsBlock = document.querySelector('#left-container');
        const backToListButtonHTML = document.querySelector('#left-container .news-mode .title-block .img-wrapper')
        const readFullArticle = document.querySelector('#left-container .news-mode button')
        if (backToListButtonHTML) {
            backToListButtonHTML.addEventListener('click', () => {
                leftNewsBlock.classList.remove('news-open');
            });
        }
        if (readFullArticle) {
            readFullArticle.addEventListener('click', () => {
                const scene = document.querySelector('a-scene');
                if (scene && scene.exitVR) {
                    scene.exitVR();
                }
                window.open(readFullArticle.dataset.url)
            });
        }

        if (window.AutoRefreshScheduler && !this.newsScheduler) {
            this.newsScheduler = new window.AutoRefreshScheduler({
                name: 'NewsTabVR',
                scheduleType: 'fixed-30',
                onRefresh: () => this.update({ ticker: 'FORCE_UPDATE' })
            });
            this.newsScheduler.start();
        }
    },

    remove: function () {
        if (this.newsScheduler) {
            this.newsScheduler.stop();
        }
        if (this.onFilterChanged) this.el.sceneEl.removeEventListener('news-filter-changed', this.onFilterChanged);
        if (this.onWatchlistDataLoaded) document.body.removeEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        if (this.onThemeChanged) this.el.sceneEl.removeEventListener('theme-changed', this.onThemeChanged);
    },

    onFilterChanged: async function(evt) {
        const filter = evt.detail.filter;
        
        const needsTickerReset = (filter === 'general' && this.currentFilter === 'general' && this.data.ticker !== 'BUSINESS');
        
        if (this.currentFilter !== filter || needsTickerReset) {
            
             if (filter === 'watchlist') {
                 const WA = window.WatchlistApp || {};
                 const Manager = WA.Manager;
                 if (Manager && Manager.checkAuthorization) {
                      const auth = await Manager.checkAuthorization();
                      if (!auth.authorized) {
                           if (window.AuthUI && window.AuthUI.showMessage) {
                               window.AuthUI.showMessage(auth.message || 'Log in to access watchlist');
                           }
                           this.el.sceneEl.emit('set-news-filter-ui', { filter: this.currentFilter });
                           return;
                      }
                 }
            }

            this.currentFilter = filter;
            
            if (filter === 'general') {
                 this.el.setAttribute('ticker-news', 'ticker', 'BUSINESS');
                 this.el.sceneEl.emit('update-news-type-2', 'BUSINESS');
            } else {
                 const WA = window.WatchlistApp || {};
                 const State = WA.State || {};
                 const Manager = WA.Manager || {};

                 if (!State.allWatchlists || State.allWatchlists.length === 0) {
                     if (Manager.updateWatchlistState) {
                         await Manager.updateWatchlistState();
                     }
                 }
                 
                 if (!this.activeWatchlistId) {
                     this.activeWatchlistId = State.currentWatchlistId;
                 }
                 if (!this.activeWatchlistId && State.allWatchlists && State.allWatchlists.length > 0) {
                     this.activeWatchlistId = State.allWatchlists[0].id || State.allWatchlists[0].watchlist_id;
                 }
                 
                 if (!this.activeWatchlistId && (!State.allWatchlists || State.allWatchlists.length === 0)) {
                     console.warn('ticker-news: Still no watchlists found after fetch attempt.');
                 }

                 const firstWatchlistName = (State.allWatchlists && State.allWatchlists.length > 0) 
                     ? (State.allWatchlists[0].name || 'Watchlist') 
                     : 'Watchlist';
                 this.el.sceneEl.emit('update-news-type-2', firstWatchlistName);
            }
            
            this.update({ ticker: 'FORCE_UPDATE' });
        }
    },

    onThemeChanged: function(evt) {
        if (!evt.detail || !evt.detail.themeMode) return;
        this.themeMode = evt.detail.themeMode;
        this.mainContentColor = (this.themeMode === 'Dark') ? '#fff' : '#111';
        if (this.articles) {
            this.createNews(this.articles);
        }
    },

    onWatchlistDataLoaded: function(evt) {
        const chartTypeControl = document.querySelector('[chart-type-control]');
        const chartData = chartTypeControl ? chartTypeControl.getAttribute('chart-type-control') : null;
        const currentAction = chartData ? chartData.selectedPrimeAction : null;
        
        if (currentAction !== 'watchlist-reports') {
             return;
        }

        const data = evt.detail;
        
        this.currentFilter = 'watchlist';

        const WA = window.WatchlistApp || {};
        const State = WA.State || {};
        
        if (State.currentWatchlistId) {
            this.activeWatchlistId = State.currentWatchlistId;
        } else {
             console.warn('ticker-news: State.currentWatchlistId is missing in data-loaded event');
        }

        this.el.sceneEl.emit('set-news-filter-ui', { filter: 'watchlist' });

        this.update({ ticker: 'FORCE_UPDATE' });
    },

    update: async function (oldData) {
        if (!this.apiManager) {
             return;
        }
        if (this.apiManager.isInitialized === false) {
             return;
        }
        if (oldData.ticker !== this.data.ticker && oldData.ticker !== 'FORCE_UPDATE') {
             if (this.currentFilter === 'watchlist') {
                 this.currentFilter = 'general';
                 this.el.sceneEl.emit('set-news-filter-ui', { filter: 'general' });
             }
        }

        if (oldData.ticker !== this.data.ticker || oldData.position !== this.data.position || oldData.ticker === 'FORCE_UPDATE') {
            try {
                this.articles = await this.fetchArticles();
                this.createNews(this.articles);
            } catch (error) {
                console.error('update: Failed to fetch articles:', error.message);
                this.showError(this.news, 'Failed to fetch articles:  ' + error.message);
            }
        }
    },
    
    createNews: function (articles) {
        if (this.news) {
            this.news.remove();
        }

        const news = document.createElement('a-plane');
        news.setAttribute('width', '7.8');
        news.setAttribute('height', '7');
        news.setAttribute('scale', '1 1 1');
        news.setAttribute('color', '#888');
        news.setAttribute('opacity', '0');
        news.setAttribute('position', `-0.25 ${this.data.position.y} ${this.data.position.z}`);
        while (news.childNodes.length > 0) {
            news.replaceChildren();
        }

        const headerRow = document.createElement('a-rounded-plane');
        headerRow.setAttribute('width', '7.5');
        headerRow.setAttribute('height', '0.7');
        headerRow.setAttribute('position', '-3.75 3.2 0.02');
        headerRow.setAttribute('color', '#444');
        news.appendChild(headerRow);

        const headerTitle = document.createElement("a-troika-text");
        let headerText = `News - ${this.data.ticker}`;
        if (articles.isWatchlistNews) {
            headerText = `${articles.watchlistName || 'Watchlist'}`;
        }
        headerTitle.setAttribute("value", headerText); 
        headerTitle.setAttribute("position", "1.5 0.35 0.01");
        headerTitle.setAttribute("font-size", "0.25");
        headerTitle.setAttribute("color", this.mainContentColor);
        headerTitle.setAttribute("align", "left");
        headerTitle.setAttribute("anchor", "left");
        headerTitle.setAttribute("depth-offset", "1");
        headerTitle.setAttribute("baseline", "center");
        headerRow.appendChild(headerTitle);

        const newsParentHTML = document.querySelector('#left-container .news-list');
        if (newsParentHTML) newsParentHTML.innerHTML = ''
        const newsBlockTitle = document.querySelector('#left-container .preview-mode .news-type p')
        // const chartBlockTitle = document.querySelector('#right-container .header-row input')
        
        let headerTitleText = this.data.ticker;
        if (articles.isWatchlistNews) {
            headerTitleText = articles.watchlistName || 'Watchlist';
        }

        if (newsBlockTitle) newsBlockTitle.textContent = headerTitleText
        
        this.el.sceneEl.emit('update-news-type-2', headerTitleText);

        const exchangeNameFromData = (this.data.ticker) ? this.data.ticker.split(':')[0] : ''

        if (articles?.noArticles) {
            const noNewsText = document.createElement("a-troika-text");
            let message = `No articles found for ${articles.tickerSymbol || 'current selection'}`;
            const exchangeName = articles.exchange || exchangeNameFromData
            if (exchangeName) {
                message += ` on exchange ${exchangeName}`;
            }
            noNewsText.setAttribute("value", message);
            noNewsText.setAttribute("position", "0 0 0.01");
            noNewsText.setAttribute("font-size", "0.3");
            noNewsText.setAttribute("color", this.mainContentColor);
            noNewsText.setAttribute("align", "center");
            noNewsText.setAttribute("max-width", "7");
            noNewsText.setAttribute("depth-offset", "1");
            news.appendChild(noNewsText);

            if (newsParentHTML) newsParentHTML.innerHTML = message

            this.el.sceneEl.emit('update-news-list-2', message);

        } else if (Array.isArray(articles) && articles.length > 0) {
            this.el.sceneEl.emit('update-news-list-2', articles);

            const pageCount = Math.ceil(articles.length / 4)
            const paginationContainer = document.querySelector('#left-container .pagination-container')
            if (paginationContainer) {
                paginationContainer.innerHTML = ''
                for (let i = 0; i < pageCount; i++) {
                    paginationContainer.innerHTML += `<div class="item">${i + 1}</div>`
                }
            }

            const paginationItems = document.querySelectorAll('#left-container .pagination-container .item')
            // const newsParentHTML = document.querySelector('#left-container .news-list'); // Already selected
            paginationItems.forEach((item, indexP) => {
                item.addEventListener('click', () => {
                    if (newsParentHTML) newsParentHTML.innerHTML = ''
                    articles.forEach((article, indexA) => {
                        if (indexA >= indexP * 4 && indexA < 4 * (indexP + 1))  this.addArticle(article, indexA);
                    });

                    const allReadFullButtons = document.querySelectorAll('#left-container .news-item .read-full');
                    allReadFullButtons.forEach((button, index) => {
                        button.addEventListener('click', () => openNewsHTML(button.dataset.index));
                    })
                })
            })

            articles.forEach((article, index) => {
                if (index < 4)  this.addArticle(article, index);
            });

            const allReadFullButtons = document.querySelectorAll('#left-container .news-item .read-full');
            const leftNewsBlock = document.querySelector('#left-container');
            const newsCategoryGeneralHTML = document.querySelector('#left-container .preview-mode .news-type p');
            const newsCategoryHTML = document.querySelector('#left-container .news-mode .header-block .category');
            const newsDateHTML = document.querySelector('#left-container .news-mode .header-block .date');
            const titleHTML = document.querySelector('#left-container .news-mode .header-block .title');
            const authorHTML = document.querySelector('#left-container .news-mode .header-block .author');
            const descriptionHTML = document.querySelector('#left-container .news-mode .description');
            const linkButtonHTML = document.querySelector('#left-container .news-mode button');

            allReadFullButtons.forEach((button, index) => {
                button.addEventListener('click', () => openNewsHTML(button.dataset.index));
            })

            function openNewsHTML(index) {
                if (articles[index]) {
                    if (newsCategoryHTML) newsCategoryHTML.innerHTML = (newsCategoryGeneralHTML ? newsCategoryGeneralHTML.textContent : 'NEWS');
                    if (newsDateHTML) newsDateHTML.innerText = new Date(articles[index].publishedDate).toLocaleDateString()
                    if (titleHTML) titleHTML.innerText = articles[index].title;
                    if (authorHTML) authorHTML.innerText = articles[index].publisher;
                    if (descriptionHTML) descriptionHTML.innerText = articles[index].description;
                    if (linkButtonHTML) linkButtonHTML.dataset.url = articles[index].url;

                    if (leftNewsBlock) leftNewsBlock.classList.add('news-open');
                }
            }
        } else {
            let message = `No articles found for ${articles.tickerSymbol || 'current selection'}`;
            const exchangeName = articles.exchange || exchangeNameFromData
            if (exchangeName) {
                message += ` on exchange ${exchangeName}`;
            }
            
            const noNewsText = document.createElement("a-troika-text");
            noNewsText.setAttribute("value", message);
            noNewsText.setAttribute("position", "0 0 0.01");
            noNewsText.setAttribute("font-size", "0.3");
            noNewsText.setAttribute("color", this.mainContentColor);
            noNewsText.setAttribute("align", "center");
            noNewsText.setAttribute("max-width", "7");
            noNewsText.setAttribute("depth-offset", "1");
            news.appendChild(noNewsText);

            if (newsParentHTML) newsParentHTML.innerHTML = "No news articles available."

            this.el.sceneEl.emit('update-news-list-2', message);
        }

        this.el.appendChild(news);
        this.news = news;
        return news;
    },

    async fetchArticles() {
        if (!this.apiManager) {
            throw new Error("Mediastack Manager not initialized yet.");
        }

        if (this.currentFilter === 'watchlist') {
             const WA = window.WatchlistApp || {};
             const State = WA.State || {};
             
             let userId = State.currentUserId || (window.currentSession && window.currentSession.user_id) || (window.currentSession && window.currentSession.user && window.currentSession.user.id);

             if (!userId) {
                 try {
                     const sessionStr = localStorage.getItem('auth_session');
                     if (sessionStr) {
                         const sessionItem = JSON.parse(sessionStr);
                         userId = sessionItem.value?.user?.id || sessionItem.value?.user?.user_id; 
                     }
                 } catch(e) {}
             }

             let watchlistId = this.activeWatchlistId || State.currentWatchlistId;
             const allWatchlists = State.allWatchlists || [];
             
             if (!watchlistId && allWatchlists.length > 0) {
                 watchlistId = allWatchlists[0].id || allWatchlists[0].watchlist_id;
                 this.activeWatchlistId = watchlistId;
             }

             const currentWatchlist = allWatchlists.find(w => w.id === watchlistId);
             const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';

             if (userId && watchlistId) {
                  try {
                      const articles = await this.apiManager.getWatchlistNews(userId, watchlistId);
                      articles.isWatchlistNews = true;
                      articles.watchlistName = watchlistName;
                      return articles;
                  } catch (err) {
                      console.error('fetchArticles: Failed to fetch watchlist news:', err);
                      return { noArticles: true, tickerSymbol: watchlistName, exchange: null };
                  }
             } else {
                 console.warn('fetchArticles: Watchlist filter active but missing userId or watchlistId', { userId, watchlistId });
                 if (!userId) {
                       return { noArticles: true, tickerSymbol: "Please Log In", exchange: null }; // Simplified
                 }
                 return { noArticles: true, tickerSymbol: "No Watchlist Selected", exchange: null };
             }
        }

        if (this.data.ticker.toUpperCase() === 'BUSINESS') {
            const articles = await this.apiManager.fetchStockNews('BUSINESS', 7, null, null);
            if (articles.length === 0) {
                return { noArticles: true, tickerSymbol: 'BUSINESS', exchange: null };
            }
            return articles;
        }

        let tickerSymbol = this.data.ticker;
        if (tickerSymbol.includes(':')) {
            tickerSymbol = tickerSymbol.split(':')[1];
        }
        const exchange = this.getExchangeFromCache(tickerSymbol);
        const searchTerm = exchange ? `${exchange}:${tickerSymbol}` : tickerSymbol;
        console.debug(`Fetching news for searchTerm: ${searchTerm}`);

        try {
            const articles = await this.apiManager.fetchStockNews(searchTerm, 7);
            if (articles.length === 0) {
                return { noArticles: true, tickerSymbol, exchange };
            }
            return articles;
        } catch (error) {
            console.error(`Error fetching news for ${searchTerm}:`, error.message);
            throw new Error(`Failed to fetch news for ${searchTerm}: ${error.message}`);
        }
    },

    addArticle: function (article, index) {
        const truncatedTitle = article.title.length > 60
            ? article.title.slice(0, article.title.lastIndexOf(' ', 60)) + "..."
            : article.title;
        const publishedDate = new Date(article.publishedDate).toLocaleDateString()

        const newsParentHTML = document.querySelector('#left-container .news-list');
        if (newsParentHTML) {
            const newsItem = `
                <div class="news-item" >
                    <div class="line">
                        <div class="source">${article.publisher}</div><div class="date">${publishedDate}</div>
                    </div>
                    <div class="main-text">
                       ${truncatedTitle}
                    </div>
                    <button class="read-full" data-index="${index}">
                        <p>Read full</p>
                        <img src="./desktop_assets/left-block/arrow-right.svg" alt="">
                    </button>
                </div>
            `
            newsParentHTML.innerHTML += newsItem;
        }
    },

    showOverlay: function (article) {
        if (this.overlay) {
            this.overlay.remove();
        }

        this.overlay = document.createElement('a-rounded-plane');
        this.overlay.setAttribute('width', '7.8');
        this.overlay.setAttribute('height', '7.8');
        this.overlay.setAttribute('color', '#222');
        this.overlay.setAttribute('opacity', '1');
        this.overlay.setAttribute('position', `-4.2 -3.9 0.11`);

        const descText = document.createElement("a-troika-text");
        const truncatedDesc = article.description.length > 200
            ? article.description.slice(0, article.description.lastIndexOf(' ', 200)) + "..."
            : article.description;
        descText.setAttribute("value", article.description);
        descText.setAttribute("position", "0.2 7 0.01");
        descText.setAttribute("font-size", "0.22");
        descText.setAttribute("color", this.mainContentColor);
        descText.setAttribute("max-width", "7");
        descText.setAttribute("align", "left");
        descText.setAttribute("anchor", "left");
        descText.setAttribute("baseline", "top");
        descText.setAttribute("overflow-wrap", "normal");
        this.overlay.appendChild(descText);

        const linkPlane = document.createElement("a-rounded-plane");
        linkPlane.setAttribute("width", "6");
        linkPlane.setAttribute("height", "0.9");
        linkPlane.setAttribute("position", "0.2 0.4 0.01");
        linkPlane.setAttribute("color", "#0066cc");
        linkPlane.setAttribute("material", "opacity: 1");
        linkPlane.setAttribute("cursor-listener", "");
        linkPlane.setAttribute("data-raycastable", "");

        linkPlane.addEventListener('fusing', () => linkPlane.setAttribute('scale', '1.1 1.1 1'));
        linkPlane.addEventListener('mouseleave', () => linkPlane.setAttribute('scale', '1 1 1'));

        linkPlane.addEventListener("click", () => {
            const sceneEl = document.querySelector("a-scene");
            const isInVR = sceneEl && sceneEl.is('vr-mode');
            window.open(article.url, "_blank", isInVR ? "" : "width=800,height=600,toolbar=no,menubar=no");
            this.hideOverlay();
        });
        this.overlay.appendChild(linkPlane);

        const linkText = document.createElement("a-troika-text");
        linkText.setAttribute("value", "Click here to read the whole article in a browser window\nClick Meta button on right controller to view browser\n Close browser tab then click 'Resume' to return");
        linkText.setAttribute("position", "3 0.45 0.01");
        linkText.setAttribute("font-size", "0.18");
        linkText.setAttribute("color", this.mainContentColor);
        linkText.setAttribute("align", "center");
        linkText.setAttribute("baseline", "center");
        linkText.setAttribute("width", "6.5");
        linkText.setAttribute("overflow-wrap", "normal");
        linkPlane.appendChild(linkText);

        const closeText = document.createElement("a-troika-text");
        closeText.setAttribute("value", "×");
        closeText.setAttribute("position", "7.2 7.2 0.22");
        closeText.setAttribute("font-size", "0.4");
        closeText.setAttribute("color", this.mainContentColor);
        closeText.setAttribute("align", "center");
        closeText.setAttribute("baseline", "center");
        this.overlay.appendChild(closeText);

        const closePlane = document.createElement("a-plane");
        closePlane.setAttribute("id", "close-news-overlay");
        closePlane.setAttribute("width", "0.4");
        closePlane.setAttribute("height", "0.4");
        closePlane.setAttribute("position", "7.2 7.2 0.2");
        closePlane.setAttribute("opacity", "0");
        closePlane.setAttribute("data-raycastable", "");
        closePlane.addEventListener("click", () => this.hideOverlay());
        this.overlay.appendChild(closePlane);

        this.overlay.addEventListener("click", (evt) => {
            if (evt.target === this.overlay) {
                this.hideOverlay();
            }
        });

        this.el.appendChild(this.overlay);
    },

    hideOverlay: function () {
        if (this.overlay) {
            this.overlay.setAttribute('animation', 'property: opacity; from: 0.9; to: 0; dur: 300; easing: easeInOutQuad;');
            setTimeout(() => {
                if (this.overlay) {
                    this.overlay.remove();
                    this.overlay = null;
                }
            }, 300);
        }
    },

    showError: function (parent, message) {
        if (!parent) {
            console.error('showError:  Parent (news) is not initialized');
            return;
        }
        while (parent.childNodes.length > 0) {
            parent.replaceChildren();
        }
        const errorText = document.createElement("a-troika-text");
        errorText.setAttribute("value", message);
        errorText.setAttribute("position", "0 0 0.01");
        errorText.setAttribute("font-size", "0.3");
        errorText.setAttribute("color", "red");
        errorText.setAttribute("align", "center");
        errorText.setAttribute("max-width", "7");
        parent.appendChild(errorText);
    },

    getExchangeFromCache: function(ticker) {
        if (!ticker) return null;
        try {
            if (typeof getCacheItem === 'function') {
                const cacheKey = `ticker_${ticker}`;
                const cachedData = getCacheItem(cacheKey);
                if (cachedData && cachedData.tickerSummary && cachedData.tickerSummary.primary_exchange) {
                    const exchange = cachedData.tickerSummary.primary_exchange;
                    if (exchange !== 'Unknown Exchange') {
                        return exchange;
                    }
                }
            } else {
                 const cacheKey = `ticker_${ticker}`;
                 const itemStr = localStorage.getItem(cacheKey);
                 if (itemStr) {
                     const item = JSON.parse(itemStr);
                     const cachedData = item.value;
                     if (cachedData && cachedData.tickerSummary && cachedData.tickerSummary.primary_exchange) {
                        const exchange = cachedData.tickerSummary.primary_exchange;
                        if (exchange !== 'Unknown Exchange') return exchange;
                     }
                 }
            }
            return null;
        } catch (e) {
            console.warn('ticker-news: Error getting exchange from cache:', e);
            return null; 
        }
    }
});
